var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 41,
    viewBox: "0 0 240 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8328 11.1559C33.8328 8.8723 32.0059 7.04541 29.7223 7.04541H5.16469C2.91622 7.04541 1.0542 8.8723 1.0542 11.1559V27.5276C1.0542 29.8112 2.91622 31.6381 5.16469 31.6381H29.7223C32.0059 31.6381 33.8328 29.8112 33.8328 27.5276V11.1559ZM7.83476 30.8301C6.3592 30.8301 5.16469 29.6356 5.16469 28.16V10.5235C5.16469 9.04796 6.3592 7.85346 7.83476 7.85346H27.0522C28.5278 7.85346 29.7223 9.04796 29.7223 10.5235V28.16C29.7223 29.6356 28.5278 30.8301 27.0522 30.8301H7.83476Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8328 11.1559C33.8328 8.8723 32.0059 7.04541 29.7223 7.04541H5.16469C2.91622 7.04541 1.0542 8.8723 1.0542 11.1559V27.5276C1.0542 29.8112 2.91622 31.6381 5.16469 31.6381H29.7223C32.0059 31.6381 33.8328 29.8112 33.8328 27.5276V11.1559ZM7.83476 30.8301C6.3592 30.8301 5.16469 29.6356 5.16469 28.16V10.5235C5.16469 9.04796 6.3592 7.85346 7.83476 7.85346H27.0522C28.5278 7.85346 29.7223 9.04796 29.7223 10.5235V28.16C29.7223 29.6356 28.5278 30.8301 27.0522 30.8301H7.83476Z",
    fill: "url(#paint0_linear_2535_851)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.725 23.4874V27.5276C68.725 29.8112 66.8981 31.6381 64.6497 31.6381H40.057C37.7733 31.6381 35.9465 29.8815 35.9465 27.5979V11.2262C35.9465 8.94256 37.7733 7.04541 40.057 7.04541H68.725V7.92372L42.727 7.99399C41.2515 7.99399 40.057 9.11822 40.057 10.5938V28.2303C40.057 29.7058 41.2515 30.8301 42.727 30.8301H61.9796C63.4552 30.8301 64.6497 29.6356 64.6497 28.16V23.4874H68.725Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.725 23.4874V27.5276C68.725 29.8112 66.8981 31.6381 64.6497 31.6381H40.057C37.7733 31.6381 35.9465 29.8815 35.9465 27.5979V11.2262C35.9465 8.94256 37.7733 7.04541 40.057 7.04541H68.725V7.92372L42.727 7.99399C41.2515 7.99399 40.057 9.11822 40.057 10.5938V28.2303C40.057 29.7058 41.2515 30.8301 42.727 30.8301H61.9796C63.4552 30.8301 64.6497 29.6356 64.6497 28.16V23.4874H68.725Z",
    fill: "url(#paint1_linear_2535_851)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.617 23.4874V27.5276C103.617 29.8112 101.79 31.6381 99.5419 31.6381H74.9492C72.6656 31.6381 70.8387 29.8815 70.8387 27.5979V11.2262C70.8387 8.94256 72.6656 7.04541 74.9492 7.04541H103.617V7.92372L77.6193 7.99399C76.1437 7.99399 74.9492 9.11822 74.9492 10.5938V28.2303C74.9492 29.7058 76.1437 30.8301 77.6193 30.8301H96.8718C98.3474 30.8301 99.5419 29.6356 99.5419 28.16V23.4874H103.617Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.617 23.4874V27.5276C103.617 29.8112 101.79 31.6381 99.5419 31.6381H74.9492C72.6656 31.6381 70.8387 29.8815 70.8387 27.5979V11.2262C70.8387 8.94256 72.6656 7.04541 74.9492 7.04541H103.617V7.92372L77.6193 7.99399C76.1437 7.99399 74.9492 9.11822 74.9492 10.5938V28.2303C74.9492 29.7058 76.1437 30.8301 77.6193 30.8301H96.8718C98.3474 30.8301 99.5419 29.6356 99.5419 28.16V23.4874H103.617Z",
    fill: "url(#paint2_linear_2535_851)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.731 7.04541V7.92372H129.551L105.731 31.6381H111.528L127.232 16.3204C128.848 14.7394 129.551 12.245 129.551 10.2425C129.551 7.11568 134.469 7.11568 134.469 10.2425V31.6381H138.51V11.0856C138.51 8.7669 136.753 7.04541 134.469 7.04541H105.731Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.731 7.04541V7.92372H129.551L105.731 31.6381H111.528L127.232 16.3204C128.848 14.7394 129.551 12.245 129.551 10.2425C129.551 7.11568 134.469 7.11568 134.469 10.2425V31.6381H138.51V11.0856C138.51 8.7669 136.753 7.04541 134.469 7.04541H105.731Z",
    fill: "url(#paint3_linear_2535_851)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M172.664 7.04541C171.575 7.04541 170.521 7.467 169.748 8.23991L166.656 11.3667C165.146 12.8774 164.408 14.9151 164.443 17.023C164.513 20.1849 159.911 20.1849 159.981 17.023C160.016 14.9151 159.279 12.8774 157.768 11.3667L154.676 8.23991C153.903 7.467 152.849 7.04541 151.76 7.04541H144.734C142.45 7.04541 140.623 8.8723 140.623 11.1559V31.6381H144.734V10.5235C144.734 8.09938 147.615 6.97515 149.266 8.62637L159.7 19.131C161.141 20.5011 163.284 20.466 164.689 19.131L175.158 8.62637C176.81 6.97515 179.691 8.16965 179.691 10.5235V31.6381H183.801V11.1559C183.801 8.8723 181.974 7.04541 179.691 7.04541H172.664Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M172.664 7.04541C171.575 7.04541 170.521 7.467 169.748 8.23991L166.656 11.3667C165.146 12.8774 164.408 14.9151 164.443 17.023C164.513 20.1849 159.911 20.1849 159.981 17.023C160.016 14.9151 159.279 12.8774 157.768 11.3667L154.676 8.23991C153.903 7.467 152.849 7.04541 151.76 7.04541H144.734C142.45 7.04541 140.623 8.8723 140.623 11.1559V31.6381H144.734V10.5235C144.734 8.09938 147.615 6.97515 149.266 8.62637L159.7 19.131C161.141 20.5011 163.284 20.466 164.689 19.131L175.158 8.62637C176.81 6.97515 179.691 8.16965 179.691 10.5235V31.6381H183.801V11.1559C183.801 8.8723 181.974 7.04541 179.691 7.04541H172.664Z",
    fill: "url(#paint4_linear_2535_851)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M239.916 1.35895V0.012207H230.02C228.205 0.012207 226.449 0.714856 225.16 2.00305L220.125 7.03869C217.548 9.61507 216.319 13.1283 216.319 16.7587C216.319 18.9837 214.504 20.5061 212.396 20.5061C210.405 20.5061 208.824 18.8081 208.824 16.6416C208.824 13.0698 207.536 9.55652 205.018 7.03869L199.982 2.00305C198.694 0.714856 196.996 0.012207 195.181 0.012207H185.227V1.35895H187.861C189.033 1.35895 190.087 1.82738 190.965 2.70569L207.243 18.9837L185.227 41H194.888L207.828 28.0596C208.473 27.4155 208.824 26.5957 208.824 25.7174C208.824 23.4338 210.405 21.9114 212.396 21.9114C214.504 21.9114 216.319 23.2582 216.319 25.6003C216.319 26.5372 216.67 27.4155 217.373 28.1181L230.255 41H239.916L217.9 18.9837L234.178 2.70569C235.056 1.82738 236.11 1.35895 237.34 1.35895H239.916Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M239.916 1.35895V0.012207H230.02C228.205 0.012207 226.449 0.714856 225.16 2.00305L220.125 7.03869C217.548 9.61507 216.319 13.1283 216.319 16.7587C216.319 18.9837 214.504 20.5061 212.396 20.5061C210.405 20.5061 208.824 18.8081 208.824 16.6416C208.824 13.0698 207.536 9.55652 205.018 7.03869L199.982 2.00305C198.694 0.714856 196.996 0.012207 195.181 0.012207H185.227V1.35895H187.861C189.033 1.35895 190.087 1.82738 190.965 2.70569L207.243 18.9837L185.227 41H194.888L207.828 28.0596C208.473 27.4155 208.824 26.5957 208.824 25.7174C208.824 23.4338 210.405 21.9114 212.396 21.9114C214.504 21.9114 216.319 23.2582 216.319 25.6003C216.319 26.5372 216.67 27.4155 217.373 28.1181L230.255 41H239.916L217.9 18.9837L234.178 2.70569C235.056 1.82738 236.11 1.35895 237.34 1.35895H239.916Z",
    fill: "url(#paint5_linear_2535_851)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2535_851",
    x1: 92.4479,
    y1: -3.49436,
    x2: 92.4479,
    y2: 38.4694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A4350"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2535_851",
    x1: 92.4479,
    y1: -3.49436,
    x2: 92.4479,
    y2: 38.4694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A4350"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2535_851",
    x1: 92.4479,
    y1: -3.49436,
    x2: 92.4479,
    y2: 38.4694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A4350"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2535_851",
    x1: 92.4479,
    y1: -3.49436,
    x2: 92.4479,
    y2: 38.4694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A4350"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2535_851",
    x1: 92.4479,
    y1: -3.49436,
    x2: 92.4479,
    y2: 38.4694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A4350"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2535_851",
    x1: 212.577,
    y1: -17.5541,
    x2: 212.577,
    y2: 52.3855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A4350"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d0cbb6307e6f8fd1db75fda195fdb676.svg";
export { ForwardRef as ReactComponent };